import { Phone, Mail, MapPin, Facebook, Instagram, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-blue-900 text-white pt-16 pb-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">

          {/* Brand and Description */}
          <div className="col-span-1">
            <div className="flex items-center space-x-2 mb-6">
              <div className="flex flex-col">
                <span className="font-bold text-3xl text-white leading-none tracking-tighter">SSS</span>
                <span className="text-xs font-bold tracking-[0.2em] text-orange-500 uppercase">Home Painting</span>
              </div>
            </div>
            <p className="text-blue-100 mb-6 italic leading-relaxed">
              "Bringing Walls to Life since 2009. Providing Quality and Trust in every stroke across Tamil Nadu."
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/profile.php?id=61583285464920"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 bg-blue-800 rounded-full hover:bg-orange-600 transition-all duration-300 shadow-lg"
              >
                <Facebook size={20} />
              </a>
              <a
                href="https://www.instagram.com/sss_home_painting/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 bg-blue-800 rounded-full hover:bg-orange-600 transition-all duration-300 shadow-lg"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-orange-500 uppercase tracking-widest border-b-2 border-orange-500/20 pb-2 inline-block">Quick Links</h3>
            <ul className="space-y-4 text-blue-100 font-medium">
              <li><a href="/" className="hover:text-orange-500 transition-colors flex items-center">› Home</a></li>
              <li><a href="/about" className="hover:text-orange-500 transition-colors flex items-center">› About Us</a></li>
              <li><a href="/contact" className="hover:text-orange-500 transition-colors flex items-center">› Contact Us</a></li>
              <li><a href="/services/interior" className="hover:text-orange-500 transition-colors flex items-center">› Our Expertise</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-orange-500 uppercase tracking-widest border-b-2 border-orange-500/20 pb-2 inline-block">Our Services</h3>
            <ul className="space-y-4 text-blue-100 font-medium">
              <li><a href="/services/interior" className="hover:text-orange-500 transition-colors">Interior Painting</a></li>
              <li><a href="/services/exterior" className="hover:text-orange-500 transition-colors">Exterior Painting</a></li>
              <li><a href="/services/wood" className="hover:text-orange-500 transition-colors">Wood & Polishing</a></li>
              <li><a href="/services/texture" className="hover:text-orange-500 transition-colors">Texture Designs</a></li>
              <li><a href="/services/waterproofing" className="hover:text-orange-500 transition-colors">Waterproofing</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-orange-500 uppercase tracking-widest border-b-2 border-orange-500/20 pb-2 inline-block">Get in Touch</h3>
            <ul className="space-y-5 text-blue-100 font-medium">
              <li className="flex items-start space-x-3">
                <MapPin className="text-orange-500 flex-shrink-0 mt-1" size={20} />
                <span>Madurai, Tamil Nadu, India. Serving All Over Tamil Nadu.</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="text-orange-500 flex-shrink-0" size={18} />
                <a href="tel:+918072127022" className="hover:text-orange-500 transition-colors">+91 80721 27022</a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="text-orange-500 flex-shrink-0" size={18} />
                <a href="mailto:pastranshiyan11@gmail.com" className="hover:text-orange-500 transition-colors">pastranshiyan11@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer Section */}
        <div className="border-t border-blue-800/60 pt-8 flex flex-col items-center text-center space-y-4">

          {/* SEMMS Solutions Credit - New Design */}
          <div className="bg-blue-950/50 px-6 py-3 rounded-full border border-blue-800/40 backdrop-blur-sm group">
            <p className="text-blue-200 text-sm font-medium flex flex-wrap items-center justify-center gap-1.5">
              Built to inspire with <Heart size={14} className="text-red-500 fill-red-500 animate-pulse" /> by
              <a
                href="https://semmssolutions.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-orange-500 font-bold hover:text-white transition-all duration-300 underline underline-offset-4 decoration-orange-500/30 hover:decoration-white"
              >
                SEMMS Solutions
              </a>
              — Elevating Your Digital Journey!
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-between w-full text-blue-400 text-[13px] font-medium pt-2">
            <p>© {currentYear} SSS Home Painting. All rights reserved.</p>
            <div className="flex space-x-6 mt-3 md:mt-0">
              <a href="/privacy-policy" className="hover:text-orange-500 transition-colors">Privacy Policy</a>
              <a href="/terms-and-conditions" className="hover:text-orange-500 transition-colors">Terms & Conditions</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;